export const areEqualAddresses = (one: string, another: string): boolean =>
  one.toLocaleLowerCase() === another.toLocaleLowerCase();
